// import { geocodeByAddress } from 'react-places-autocomplete'

import cookie from "react-cookies"
import axios from 'axios';

import { getRouteMap4D, searchInHouse } from '../../model/common';


import { wdType, stypes } from "./common";
import { mapSdk } from '../../model/base';

const map4DKeyApi = '847bd3a139a982d07c03ba07e4ca443c';

export const WDCalendarTemplate =
'<div class="daterangepicker dropdown-menu home single-calendar">' +
'<p class="c-title">' +
"Chọn ngày" +
"</p>" +
'<div class="calendar left">' +
'<div class="calendar-table"></div>' +
'<div class="daterangepicker_input">' +
`<p class="c-title">Chọn giờ</p>` +
'<div class="calendar-time">' +
`<p class='pickup'>Giờ nhận xe` +
"<div></div>" +
"</div>" +
"</div>" +
"</div>" +
'<div class="ranges">' +
'<div class="range_inputs">' +
'<button class="applyBtn" disabled="disabled" type="button"></button> '  +
'</div>' +
'</div>' +
"</div>";

export const WDECalendarTemplate =
'<div class="daterangepicker dropdown-menu home single-calendar">' +
'<p class="c-title">' +
"Chọn ngày" +
"</p>" +
'<div class="calendar left">' +
'<div class="calendar-table"></div>' +
'<div class="daterangepicker_input">' +
`<p class="c-title">Chọn giờ</p>` +
'<div class="calendar-time">' +
`<p class='pickup'>Giờ trả xe` +
"<div></div>" +
"</div>" +
"</div>" +
"</div>" +
'<div class="ranges">' +
'<div class="range_inputs">' +
'<button class="applyBtn" disabled="disabled" type="button"></button> ' +
'</div>' +
'</div>' +
"</div>";



export function parseAddressArrayToLocationArray(addressArray, callback) {

    if (addressArray.length == 1) {
        if (addressArray[0] == "Hồ Chí Minh") {
            let locationArray = [];
            locationArray[0] = { 
                lat: 10.771905,
                lng: 106.698264
            }
            callback(locationArray);
            return;
        }
    }

    let promiseArray = []
        addressArray.map(address => {
        
                let locs = {}
        
                searchInHouse(address).then((response) => { 
                
                    if (address === "Hồ Chí Minh") {
                        locs = {
                            lat: 10.771905,
                            lng: 106.698264
                        }
                    } else  {
                        const loc = response.data.data.locations[0]		
                        locs = {lat: loc.lat, lng: loc.lon}
                    }
                    promiseArray.push(locs)
                    callback(promiseArray)
                })
            
        })


}

export function parseAddressToLocationWithLatLng(address, lat, lng, callback) {
    // For city featured, use lat, lng of dicstrict 1 of HCM
    if (address === "Hồ Chí Minh") {
        callback({
            lat: 10.771905,
            lng: 106.698264
        })
        return;
    }

    if (lat && lng) {
        callback({
            lat: lat,
            lng: lng
        })
        return;
    }

}

// export function parseAddressToLocation(address, callback) {   
//     geocodeByAddress(address).then((value) => {
//         callback({
//             lat: value[0].geometry.location.lat(),
//             lng: value[0].geometry.location.lng()
//         })
//     })
// }

export function calculateDistance(wdOneWay, locationArray, callback) {
    const mapSdkVal = mapSdk;

    switch (mapSdkVal) {
        case 1:
            if (locationArray.length === 1) return callback(0, 0, 0);

            var platform = new window.H.service.Platform({
                apikey: 'jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc',
            });


            const waypoints = []
            for (let i = 1; i < locationArray.length; i++) {
                const location = locationArray[i];
                waypoints.push(`via=${location.lat},${location.lng}`);
            }
            // here routing service
            let params = {
                transportMode: "car",
                return: "polyline,summary",
                apikey: 'jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc',
                origin: `${locationArray[0].lat},${locationArray[0].lng}`,
                destination: `${locationArray[0].lat},${locationArray[0].lng}`,
            };
            
            let via;

            if (waypoints.length > 1) {
               via = waypoints.join("&")
            } else {
               via = waypoints.toString()
            }
        
        
            axios.get(`https://router.hereapi.com/v8/routes?${via}`, {
					'params': params
			}).then((response) => {
                    let wdDistanceOW = 0 ;
                    const myroute = response.data.routes;
                    
                    for (var i = 0; i < myroute[0].sections.length - 1; i++) {

                        const leg = myroute[0].sections[i].summary;
                        wdDistanceOW += leg.length / 1000;
                    }


                    const leg = myroute[0].sections[0].summary.length / 1000 
                    
                    const wdDistanceBackOW = myroute[0].sections[myroute[0].sections.length - 1].summary.length / 1000;
            
                    return callback(
                        wdOneWay ? wdDistanceOW : (wdDistanceOW + wdDistanceBackOW),  //Main value
                        wdDistanceOW,
                        wdDistanceBackOW
                    )
			})
           
            break;
        
        case 2:
            if (locationArray.length === 1) return callback(0, 0, 0)

       
            const wpnts = []
            for (let i = 1; i < locationArray.length; i++) {
                    const location = locationArray[i];
                    wpnts.push(`${location.lat},${location.lng}`);
            }
            
            const points = wpnts.length > 0 ? wpnts.join(";") : ""
            const origin =  `${locationArray[0].lat},${locationArray[0].lng}`;
            const destination = `${locationArray[0].lat},${locationArray[0].lng}`;
        
        
           getRouteMap4D(origin, destination, points).then((response) => { 
                
                if (response.data.code === "ok") {
                    let wdDistanceOW = 0
                    const myroute = response.data.result.routes[0];
                    for (let i = 0; i < myroute.legs.length - 1; i++) {
                            wdDistanceOW += myroute.legs[i].distance.value / 1000;
                    }
                    const wdDistanceBackOW = myroute.legs[myroute.legs.length - 1].distance.value / 1000
        
                    return callback(
                            wdOneWay ? wdDistanceOW : (wdDistanceOW + wdDistanceBackOW),  //Main value
                            wdDistanceOW,
                            wdDistanceBackOW
                    )
                    
                }
        
            })    
            break;
        default:
            // google direction
            // const waypts = []
            // for (let i = 1; i < locationArray.length; i++) {
            //     const location = locationArray[i];
            //     waypts.push({
            //         location: `${location.lat},${location.lng}`,
            //         // stopover: true
            //     });
            // }
            // const directionsService = new window.google.maps.DirectionsService();
            // directionsService.route({
            //     origin: `${locationArray[0].lat},${locationArray[0].lng}`,
            //     destination: `${locationArray[0].lat},${locationArray[0].lng}`,
            //     waypoints: waypts,
            //     // optimizeWaypoints: true,
            //     travelMode: 'DRIVING'
            // }, function (response, status) {
            //     if (status === 'OK') {
            //         let wdDistanceOW = 0
            //         const myroute = response.routes[0];
            //         for (let i = 0; i < myroute.legs.length - 1; i++) {
            //             wdDistanceOW += myroute.legs[i].distance.value / 1000;
            //         }
            //         const wdDistanceBackOW = myroute.legs[myroute.legs.length - 1].distance.value / 1000
            //         return callback(
            //             wdOneWay ? wdDistanceOW : (wdDistanceOW + wdDistanceBackOW),  //Main value
            //             wdDistanceOW,
            //             wdDistanceBackOW
            //         )
            //     }
            // })
    }
}

// export function getDirectionsResponse(wdOneWay, locationArray, callback) {
//     const directionsService = new window.google.maps.DirectionsService;

//     if (locationArray.length > 1 && !wdOneWay) { // 2 way
//         // Directions response backward way line in current map
//         directionsService.route({
//             origin: locationArray[locationArray.length - 1],
//             destination: locationArray[0],
//             waypoints: [],
//             // optimizeWaypoints: true,
//             travelMode: 'DRIVING'
//         }, (responseBackOW, status) => {
//             if (status === 'OK') {
//                 // Directions response forward way line in current map (Put in here to make order of way lines)
//                 var waypts = [];
//                 for (let i = 1; i < locationArray.length - 1; i++) {
//                     waypts.push({
//                         location: locationArray[i],
//                         // stopover: true
//                     });
//                 }
//                 directionsService.route({
//                     origin: locationArray[0],
//                     destination: locationArray[locationArray.length - 1],
//                     waypoints: waypts,
//                     // optimizeWaypoints: true,
//                     travelMode: 'DRIVING'
//                 }, (response, status) => {
//                     if (status === 'OK') {
//                         callback({
//                             directionsResponse: response,
//                             directionsResponseBackOW: responseBackOW
//                         })
//                     }
//                 })
//             }
//         })

//     } else {
//         // Directions response forward way line in current map

//         var waypts = [];
//         for (let i = 1; i < locationArray.length - 1; i++) {
//             waypts.push({
//                 location: locationArray[i],
//                 // stopover: true
//             });
//         }

//         directionsService.route({
//             origin: locationArray[0],
//             destination: locationArray[locationArray.length - 1],
//             waypoints: waypts,
//             // optimizeWaypoints: true,
//             travelMode: 'DRIVING'
//         }, (response, status) => {
//             if (status === 'OK') {
//                 callback({
//                     directionsResponse: response
//                 })
//             }
//         })

//     }
// }

export function is2ArrayEqual(ar1, ar2) {
    if (ar1.length !== ar2.length) return false
    for (let i = 0; i < ar1.length; i++) {
        if (ar1[i] !== ar2[i]) {
            return false
        }
    }
    return true
}

export function parseWdMinHour(wdMinHourCT, wdMinHour, wdMinHourOW) {
    wdMinHourCT = parseInt(wdMinHourCT)
    wdMinHour = wdMinHour.split(";")
    for (let i = 0; i < wdMinHour.length; i++) {
        const wdMinHourElement = wdMinHour[i].split("-")
        wdMinHour[i] = {
            fromDistance: parseInt(wdMinHourElement[0]),
            toDistance: parseInt(wdMinHourElement[1]),
            baseMinHour: parseInt(wdMinHourElement[2]),
            speed: parseInt(wdMinHourElement[3]),
        }
    }
    wdMinHourOW = wdMinHourOW.split(";")
    for (let i = 0; i < wdMinHourOW.length; i++) {
        const wdMinHourOWElement = wdMinHourOW[i].split("-")
        wdMinHourOW[i] = {
            fromDistance: parseInt(wdMinHourOWElement[0]),
            toDistance: parseInt(wdMinHourOWElement[1]),
            baseMinHour: parseInt(wdMinHourOWElement[2]),
            speed: parseInt(wdMinHourOWElement[3]),
        }
    }
    return {
        wdMinHourCT,
        wdMinHour,
        wdMinHourOW
    }
}

export function checkWdMinHour(isCityTourMode, wdOneWay, wdDistance, startDate, endDate, wdMinHour) {
    /* Return:
    + undefined : valid
    + number: invalid 
    */
    let hourCurrent = (endDate - startDate) / 3600000
    wdDistance = parseInt(wdDistance)

    if (isCityTourMode) {
        if (hourCurrent < wdMinHour.wdMinHourCT) {
            return wdMinHour.wdMinHourCT
        }

    } else if (wdOneWay) {
        for (const wdMinHourOWElement of wdMinHour.wdMinHourOW) {
            if (wdDistance >= wdMinHourOWElement.fromDistance && wdDistance < wdMinHourOWElement.toDistance) {
                const hourMin = wdMinHourOWElement.speed === 0 ? wdMinHourOWElement.baseMinHour : (wdMinHourOWElement.baseMinHour + (wdDistance - wdMinHourOWElement.fromDistance) / wdMinHourOWElement.speed)
                if (hourCurrent < hourMin) {
                    return Math.ceil(hourMin)
                }
            }
        }

    } else {
			for (const wdMinHourElement of wdMinHour.wdMinHour) {
				
            if (wdDistance >= wdMinHourElement.fromDistance && wdDistance < wdMinHourElement.toDistance) {
                const hourMin = wdMinHourElement.speed === 0 ? wdMinHourElement.baseMinHour : (wdMinHourElement.baseMinHour + (wdDistance - wdMinHourElement.fromDistance) / wdMinHourElement.speed)
            
                if (hourCurrent < hourMin) {
                    return Math.ceil(hourMin)
                 }
			}
        }
    }

    return undefined
}

export function parseWdLocations(wdLocations) {
    const addressArray = [], locationArray = []
    wdLocations = wdLocations.split(",")
    for (let i = 0; i < wdLocations.length; i++) {
        const tempArray = wdLocations[i].split("-")
        locationArray.push({ lat: parseFloat(tempArray[0]), lng: parseFloat(tempArray[1]) })
        addressArray.push(Buffer.from(tempArray[2], 'base64').toString())
    }
    return {
        addressArray,
        locationArray
    }
}

export function getCookiesRoutes() {
    const cRoutes = cookie.load("_mroutes");
    if (cRoutes) {
        const isCityTourMode = cRoutes[0]
        const wdOneWay = cRoutes[1]
        const wdDistance = cRoutes[2]
        const wdDistanceOW = cRoutes[3]
        const wdDistanceBackOW = cRoutes[4]
        const wdLocations = cRoutes[5]
        const { addressArray, locationArray } = parseWdLocations(wdLocations)
        const deliveryAddressChangedFlag = cRoutes[6]


        return {
            isCityTourMode,
            wdOneWay,
            addressArray,
            locationArray,
            wdDistance,
            wdDistanceOW,
            wdDistanceBackOW,
            wdLocations,
            deliveryAddressChangedFlag,
        }
    }
    return null
}

export function setCookiesRoutes(params) {
    const { isCityTourMode, wdOneWay, wdDistance, wdDistanceOW, wdDistanceBackOW, wdLocations, deliveryAddressChangedFlag } = params
    const cRoutes = cookie.load("_mroutes") || [];
    if (isCityTourMode !== undefined) {
        cRoutes[0] = isCityTourMode
    }
    if (wdOneWay !== undefined) {
        cRoutes[1] = wdOneWay
    }
    if (wdDistance !== undefined) {
        cRoutes[2] = wdDistance
    }
    if (wdDistanceOW !== undefined) {
        cRoutes[3] = wdDistanceOW
    }
    if (wdDistanceBackOW !== undefined) {
        cRoutes[4] = wdDistanceBackOW
    }
    if (wdLocations !== undefined) {
        cRoutes[5] = wdLocations
    }
    if (deliveryAddressChangedFlag !== undefined) {
        cRoutes[6] = deliveryAddressChangedFlag
    }

    cookie.save("_mroutes", cRoutes, { path: '/' });
}

export function findLimitDistance(wdMinHour, distance) { 

	if (distance === 0) {
		return undefined
	}

	let res = wdMinHour.split(";");
	let tokens;
	let limitDistances;

	for(let i=0; i < res.length; i++) { 
			res[i] = res[i].split("-")
	 
			limitDistances = res[i]
		
			if(limitDistances[0] <= distance && distance <= limitDistances[1]) { 
				tokens = limitDistances;
			}
	}
	return tokens
	
}

export function getMinHourFromLimitDistance(wdMinHour, distance) { 

	let tokens = findLimitDistance(wdMinHour, distance)

	if (tokens === undefined) {
		return undefined
	}
  
	let minHour;

	for(let i =0; i < tokens.length; i++) { 
		
			let minDistance = parseInt(tokens[i]);
			let maxDistance = parseInt(tokens[++i]);
			let fixedMinHour = parseInt(tokens[++i]);
			let extraDistance = parseInt(tokens[++i]);

			if (extraDistance === 0) { 
					minHour =  fixedMinHour;
			} else { 
					minHour = fixedMinHour + (distance - minDistance) / extraDistance;
			}
			break;
	}
	
	return Math.ceil(minHour)
}



export function getDurationTime(wdMode, wdMinHour, distance) {

	let fixDurationTime = [0, 2, 4, 6, 8, 10, 12, 16, 24, 36, 48, 60]
	let minHour = getMinHourFromLimitDistance(wdMinHour, distance)
	let currentDuration;

	if (wdMode && minHour === undefined) {

	 	currentDuration = fixDurationTime

	} else if (!wdMode && minHour === undefined) {	

		currentDuration = fixDurationTime
		currentDuration.shift()
		currentDuration.unshift(0)
	
	} else  { 

		currentDuration = fixDurationTime.filter(time => time > minHour);
		for (let i = 0; i <= fixDurationTime.length - 1; i++) {
			if (minHour >= fixDurationTime[i]) {
				currentDuration.unshift(0, minHour);
				break;
			}
		}
	}
	
	return currentDuration
}

export function getEndDatewd(time, startDatewd) {

	let endDatewd = startDatewd.clone().add(time, 'hours')
	endDatewd.set({
		hour: endDatewd.get('hour'),
		minute: endDatewd.get('minute'),
		second: 0,
		milliseconds: 0
	})

	return endDatewd
}

export function createMap(platform, defaultLayers, locAddress, mapName) {
    var mapId = mapName ? mapName : 'fix-map';
    var list = document.getElementById(mapId);   // Get the <ul> element with id="myList"
    if (list && list.childNodes && list.childNodes.length > 0) {
        list.removeChild(list.childNodes[0]);  
    }

    //Step 2: initialize a map - this map is centered over New Delhi
    var mapContainer = document.getElementById(mapId), routeInstructionsContainer = document.getElementById('panel');
    var defaultLayers = platform.createDefaultLayers();

    // Step 2: initialize a map - this map is centered over Berlin
    var map = new window.H.Map(mapContainer,
        defaultLayers.vector.normal.map, {
        center: {lat: locAddress[0].lat, lng: locAddress[0].lng},
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
    });

    return map;
}

export function initMap (wdOneWay, refs, locAddress, dragable, mapName, stype) {

   

    if (stype == stypes.WD) {


               // Using Map4D Api 
            if (mapName === 'map-deli') {
                if (document.getElementsByClassName("mf-map4d")[1]) {
                    document.getElementsByClassName("mf-map4d")[1].remove()
                }
            } 
            
            else {
                if (document.getElementsByClassName("mf-map4d") && document.getElementsByClassName("mf-map4d")[0]) {
                    document.getElementsByClassName("mf-map4d")[0].remove()
                }
            }    
        



        let icCircle =  `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#1b468d" stroke="white" stroke-width="1" /></svg>`; 
        let zoom = 16
        let centerLoc = {lat: locAddress[0].lat, lng: locAddress[0].lng}
     

        if (locAddress.length > 1 && !locAddress.includes("") && mapName === '') {
            centerLoc = new window.map4d.CoordinateTransformer([{lat: locAddress[0].lat, lng: locAddress[0].lng}, {lat: locAddress[locAddress.length-1].lat, lng: locAddress[locAddress.length-1].lng}]).center
            zoom = 10
        } else if (locAddress.length > 1 && mapName === 'map-deli') {
            centerLoc = new window.map4d.CoordinateTransformer([{lat: locAddress[0].lat, lng: locAddress[0].lng}, {lat: locAddress[1].lat, lng: locAddress[1].lng}]).center
            zoom = 13
        }  
  

        let mapWD = new window.map4d.Map(refs.current, {
            center: centerLoc,
            zoom: zoom,
            controls: true
        })


        let directionsRender = new window.map4d.DirectionsRenderer({
            activeStrokeColor: '#ff00ff',
            activeOutlineWidth: 0,
            activeOutlineColor: '#000000',
            activeStrokeWidth: 1

        })


        if(locAddress.length > 1) {

            const wpnts = [];
            let waypointMarkerOptions = []
        
            for (let i = 1; i < locAddress.length; i++) {
                const location = locAddress[i];
                wpnts.push(`${location.lat},${location.lng}`);
                if (!wdOneWay) {
                    waypointMarkerOptions.push({
                        position: {lat: location.lat, lng: location.lng},
                        draggable: false,
                        visible: true,
                        iconView: icCircle,
                        anchor: [0.3, 0.5],
                    })
                }
            }

            
            
            const points = wpnts.length > 0 ? wpnts.join(";") : ""
            const origin = `${locAddress[0].lat},${locAddress[0].lng}`;
            const destination = wdOneWay ? `${locAddress[locAddress.length-1].lat},${locAddress[locAddress.length-1].lng}` : `${locAddress[0].lat},${locAddress[0].lng}`;

            getRouteMap4D(origin, destination, points).then((response) => {
          

                if (response.data.code === "ok") {

                const legs = response.data.result.routes[0].legs
                const stLoc = response.data.result.routes[0].legs[0].startLocation
                let etLoc = response.data.result.routes[0].legs[[legs.length - 1]].endLocation

                    directionsRender.setOptions({
                        routes: response.data,
                        originMarkerOptions: {
                            position: {lat: stLoc.lat, lng: stLoc.lng },
                            title: "Start",
                            draggable: false,
                            visible: true,
                            iconView: icCircle,
                            anchor: [0.25, 0.5],
                        },
                        destinationMarkerOptions: {
                            position: {lat: etLoc.lat, lng: etLoc.lng},
                            title: "End",
                            visible: true,
                            draggable: false,
                            iconView: icCircle,
                            anchor: [0.25, 0.5],
                            userInteractionEnabled: false
                        },
                        waypointMarkerOptions: waypointMarkerOptions,
                        activeStrokeColor: '#0080ff',
                        activeOutlineWidth: 0,
                        activeStrokeWidth: 2,
                        inactiveOutlineWidth: 0,

                    })
                
                    directionsRender.setMap(mapWD)
                }
    
            })
            
        
        
        } else { 


            directionsRender.setOptions({
                originMarkerOptions: {
                    position: {lat: locAddress[0].lat, lng: locAddress[0].lng },
                    title: "Start",
                    draggable: false,
                    visible: true,
                    iconView: icCircle,
                    anchor: [0.25, 0.5],
                },
                destinationMarkerOptions: {
                    position: {lat: locAddress[0].lat, lng: locAddress[0].lng},
                    title: "End",
                    visible: true,
                    draggable: false,
                    iconView: icCircle,
                    userInteractionEnabled: false,
                    anchor: [0.25, 0.5],
                },
            })
            
            directionsRender.setMap(mapWD)
    

        }

   

        return; 
       
    } else {
              // Using Map4D Api 
            if (mapName === 'deli-map') {
                if (document.getElementsByClassName("mf-map4d")[0]) {

                    document.getElementsByClassName("mf-map4d")[0].remove()
                }
            } 

           
            
            let icCircle =  `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#1b468d" stroke="white" stroke-width="1" /></svg>`; 
            let zoom = 16
            let centerLoc = {lat: locAddress[0].lat, lng: locAddress[0].lng}
                if (locAddress.length > 1 && mapName === 'deli-map') {
                    centerLoc = new window.map4d.CoordinateTransformer([{lat: locAddress[0].lat, lng: locAddress[0].lng}, {lat: locAddress[1].lat, lng: locAddress[1].lng}]).center
                    zoom = 13
                }  


                let map4D = new window.map4d.Map(refs.current, {
            		center: centerLoc,
            		zoom: zoom,
            		controls: false,
            	});

                let directionsRender = new window.map4d.DirectionsRenderer({
                    activeStrokeColor: '#ff00ff',
                    activeOutlineWidth: 0,
                    activeOutlineColor: '#000000',
                    activeStrokeWidth: 1
                })

            
        
        
                if(locAddress.length > 1) {
        
                    const wpnts = [];
                    let waypointMarkerOptions = []
                
                    for (let i = 1; i < locAddress.length; i++) {
                        const location = locAddress[i];
                        wpnts.push(`${location.lat},${location.lng}`);
                        if (!wdOneWay) {
                            waypointMarkerOptions.push({
                                position: {lat: location.lat, lng: location.lng},
                                draggable: false,
                                visible: true,
                                iconView: icCircle,
                                anchor: [0.3, 0.5],
                            })
                        }
                    }
        
                
                    
                    const points = wpnts.length > 0 ? wpnts.join(";") : ""
                    const origin = `${locAddress[0].lat},${locAddress[0].lng}`;
                    const destination = wdOneWay ? `${locAddress[locAddress.length-1].lat},${locAddress[locAddress.length-1].lng}` : `${locAddress[0].lat},${locAddress[0].lng}`;
        
                    getRouteMap4D(origin, destination, points).then((response) => {
                  
        
                        if (response.data.code === "ok") {
        
                        const legs = response.data.result.routes[0].legs
                        const stLoc = response.data.result.routes[0].legs[0].startLocation
                        let etLoc = response.data.result.routes[0].legs[[legs.length - 1]].endLocation
        
                            directionsRender.setOptions({
                                routes: response.data,
                                originMarkerOptions: {
                                    position: {lat: stLoc.lat, lng: stLoc.lng },
                                    title: "Start",
                                    draggable: false,
                                    visible: true,
                                    iconView: icCircle,
                                    anchor: [0.25, 0.5],
                                },
                                destinationMarkerOptions: {
                                    position: {lat: etLoc.lat, lng: etLoc.lng},
                                    title: "End",
                                    visible: true,
                                    draggable: false,
                                    iconView: icCircle,
                                    anchor: [0.25, 0.5],
                                    userInteractionEnabled: false
                                },
                                waypointMarkerOptions: waypointMarkerOptions,
                                activeStrokeColor: '#0080ff',
                                activeOutlineWidth: 0,
                                activeStrokeWidth: 2,
                                inactiveOutlineWidth: 0,
        
                            })
                        
                            directionsRender.setMap(map4D)
                        }
            
                    })

                
 
                } else { 

                    if (mapName === 'deli-map' || mapName === 'loc-map') {
                        directionsRender.setOptions({
                            originMarkerOptions: {
                                position: {lat: locAddress[0].lat, lng: locAddress[0].lng },
                                title: "Start",
                                draggable: false,
                                visible: true,
                                iconView: icCircle,
                                anchor: [0.25, 0.5],
                            },
                            destinationMarkerOptions: {
                                position: {lat: locAddress[0].lat, lng: locAddress[0].lng},
                                title: "End",
                                visible: true,
                                draggable: false,
                                iconView: icCircle,
                                userInteractionEnabled: false,
                                anchor: [0.25, 0.5],
                            },
                        })
                    } else {

                        let circle = new window.map4d.Circle({
                            center: centerLoc,
                            fillColor: "#767676",
                            fillOpacity: 0.3,
                            radius: 300,
                            strokeWidth: 1.0,
                            strokeColor: "#767676",
                        });
                        circle.setMap(map4D);
                    }
               
                    
                    directionsRender.setMap(map4D)
            
        
                }
    }

}

export function createInfoHSBubble(ui) {
    // Create info bubble
    var HSIsland = new H.ui.InfoBubble({ lng: 111.6237953812062, lat: 16.602658636573388}, {
        content: '<p>Quần đảo Hoàng Sa <br/> (Việt Nam)</p>'
    });

 
    // Add info bubble to the UI:
    ui.addBubble(HSIsland);
}

export function createInfoTSBubble(ui) {
    // Create info bubble

    var TSIsland = new H.ui.InfoBubble({ lng: 115.8263796310228, lat: 10.72395633185012}, {
        content: '<b>Quần đảo Trường Sa <br/> (Việt Nam)</b>'
    });
    // Add info bubble to the UI:
    ui.addBubble(TSIsland);
}

function addDraggableMarker(map, location, behavior){

    var marker = new window.H.map.Marker({lat:location.lat, lng: location.lng}, {
      // mark the object as volatile for the smooth dragging
      volatility: true
    });
    // Ensure that the marker can receive drag events
    marker.draggable = true;
    map.addObject(marker);
  
    // disable the default draggability of the underlying map
    // and calculate the offset between mouse and target's position
    // when starting to drag a marker object:
    map.addEventListener('dragstart', function(ev) {
        var target = ev.target;
        var pointer = ev.currentPointer;

        if (target instanceof window.H.map.Marker) {
            var targetPosition = map.geoToScreen(target.getGeometry());
            target['offset'] = new window.H.math.Point(pointer.viewportX - targetPosition.x, pointer.viewportY - targetPosition.y);
            behavior.disable();
        }
    }, false);
  
  
    // re-enable the default draggability of the underlying map
    // when dragging has completed
    map.addEventListener('dragend', function(ev) {
      var target = ev.target;
      if (target instanceof window.H.map.Marker) {
        behavior.enable();
      }
    }, false);
  
    // Listen to the drag event and move the position of the marker
    // as necessary
    map.addEventListener('drag', function(ev) {
      var target = ev.target,
          pointer = ev.currentPointer;
      if (target instanceof window.H.map.Marker) {
        target.setGeometry(map.screenToGeo(pointer.viewportX - target['offset'].x, pointer.viewportY - target['offset'].y));
      }
    }, false);
}

export function onError(error) {
  console.log('Can\'t reach the remote server');
}


   
    // // Step 1: initialize communication with the platform
    // var platform = new window.H.service.Platform({
    //     useHTTPS: true,
    //     useCIT: true,
    //     apikey: 'jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc'
    // });
    // var pixelRatio = window.devicePixelRatio || 1;
    // var defaultLayers = platform.createDefaultLayers({
    //     tileSize: pixelRatio === 1 ? 256 : 512,
    //     ppi: pixelRatio === 1 ? undefined : 320
    // });

    // // init map
    // var map = createMap(platform, defaultLayers, locAddress, mapName);
    // var defaultLayers = platform.createDefaultLayers();



    //  //Step 3: make the map interactive
    // // MapEvents enables the event system
    // // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    // var behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
    // behavior.disable(window.H.mapevents.Behavior.WHEELZOOM);

    // // Create the default UI components
    // var ui = window.H.ui.UI.createDefault(map, defaultLayers);

    // createInfoHSBubble(ui);
    // createInfoTSBubble(ui);

    // if (dragable) {
    //     addDraggableMarker(map, locAddress[locAddress.length - 1], behavior)
    // }


  
    //   // Define a callback function to process the routing response:
    // var onResult = function(result) {
    //     // var svgMarkup = '<svg width="18" height="18" ' +
    //     //     'xmlns="http://www.w3.org/2000/svg">' +
    //     //     '<circle cx="8" cy="8" r="8" ' +
    //     //     'fill="#1b468d" stroke="white" stroke-width="1" />' +
    //     //     '</svg>',
    //     var svgMarkup = '<svg width="18" height="18" ' +
    //         'xmlns="http://www.w3.org/2000/svg">' +
    //         '<circle cx="8" cy="8" r="8" ' +
    //         'fill="#1b468d" stroke="white" stroke-width="1" />' +
    //         '</svg>',
    //         dotIcon = new window.H.map.Icon(svgMarkup, {anchor: {x:8, y:8}}),
    //         group = new window.H.map.Group(),
    //         i,
    //         j;
    //     var index = 0;

       
    //    result.routes[0].sections.forEach((section) => {
 
        
    //         // poly routes
    //         // decode LineString from the flexible polyline
    //         let linestring = window.H.geo.LineString.fromFlexiblePolyline(section.polyline);
        
    //         // Create a polyline to display the route:
    //         let polyline = new window.H.map.Polyline(linestring, {
    //             style: {
    //             lineWidth: 4,
    //             strokeColor: 'rgba(0, 128, 255, 0.7)'
    //             }
    //         });

        
    //         // Add the polyline to the map
    //         map.addObject(polyline);
    //         // And zoom to its bounding rectangle
    //         map.getViewModel().setLookAtData({
    //             bounds: polyline.getBoundingBox()
    //         });

    //         // marker
    //         let poly = window.H.geo.LineString.fromFlexiblePolyline(section.polyline).getLatLngAltArray();

    //         let actions = section.actions;

    //         // Add a marker for each maneuver
    //         for (i = 0; i < actions.length; i += 1) {
    //             if (i != 0 && i != actions.length -1) {
    //                 continue;
    //             }
    //             let action = actions[i];
    //             var marker = new window.H.map.Marker({
    //                 lat: poly[action.offset * 3],
    //                 lng: poly[action.offset * 3 + 1]},
    //                 {icon: dotIcon});
    //             marker.instruction = action.instruction;
    //             group.addObject(marker);
    //         }
    //         map.addObject(group);
            
    //         if (locAddress[0].lat == locAddress[1].lat && locAddress[0].lng == locAddress[1].lng) {
    //             map.setZoom(17, true)
    //         }
    //     });		
    // };


      
    
    // // Call calculateRoute() with the routing parameters,
    // // the callback and an error callback function (called if a
    // // communication error occurs):
    // // platform.getRoutingService().calculateRoute(params, onResult,
    // // 	function(error) {
    // // 		alert(error.message);
    // // 	}
    // // );
    // if (locAddress.length < 2) {
    //     var svgMarkup = '<svg width="18" height="18" ' +
    //         'xmlns="http://www.w3.org/2000/svg">' +
    //         '<circle cx="8" cy="8" r="8" ' +
    //         'fill="#1b468d" stroke="white" stroke-width="1" />' +
    //         '</svg>',
    //         dotIcon = new window.H.map.Icon(svgMarkup, {anchor: {x:8, y:8}}),
    //         group = new window.H.map.Group();
        
    //     var marker = new window.H.map.Marker({
    //         lat: locAddress[0].lat,
    //         lng: locAddress[0].lng},
    //         {icon: dotIcon});
    //     group.addObject(marker);
    //     map.addObject(group);
       
    //     return;
    // }

    // for (var i = 0; i < locAddress.length; i++) {
    //     var router = platform.getRoutingService(null, 8);
    //     var	routeRequestParams;
    //     if (i == locAddress.length - 1) {
    //         if (wdOneWay) {
    //             continue;
    //         }
    //         routeRequestParams = {
    //             routingMode: 'fast',
    //             transportMode: 'car',
    //             origin: locAddress[i].lat + "," + locAddress[i].lng,
    //             destination: locAddress[0].lat + "," + locAddress[0].lng,
    //             return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
    //         };
    //     } else {
    //         routeRequestParams = {
    //             routingMode: 'fast',
    //             transportMode: 'car',
    //             origin: locAddress[i].lat + "," + locAddress[i].lng,
    //             destination: locAddress[i + 1].lat + "," + locAddress[i + 1].lng,
    //             return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
    //         };	
    //     }
            

    //     router.calculateRoute(
    //         routeRequestParams,
    //         onResult,
    //         onError
    //     );
    // }

    // }